// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need; 

import VendorScriptLoader from './utility/vendor-script-loader';
import LazyLoad from './utility/lazy-load';
import AnchorSmoothScroll from './utility/anchor-smooth-scroll';
import HeaderNavHeader from './components/header-nav';
// import NavLinkToggler from './utility/nav-link-toggler';
import './fonts.js';

// Google Maps :: when loading the Google Maps js API a callback is required to be passed, but since
// we are already firing an event when the script is loaded, there's no need for this callback.
// We define it just to avoid the console error.
window.initMap = () => {};

/**
 * Code-splitting :: Blocks
 *
 * Manages blocks that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerBlocks() {
  if ( document.querySelector('.js-example-block') ) {
    import('~scripts/blocks/example');
  }
  if ( document.querySelector('.icon-text-block') ) {
    import('~scripts/blocks/icon-text');
  }
  if (document.querySelector('.use-case-accordion-block')) {
    import('~scripts/blocks/use-case-accordion');
  }
  if (document.querySelector('.featured-text-block')) {
    import('~scripts/blocks/featured-text');
  }
  if (document.querySelector('.cta-large-block')) {
    import('~scripts/blocks/cta-large');
  }
  if (document.querySelector('.cta-small-block')) {
    import('~scripts/blocks/cta-small');
  }
  if (document.querySelector('.standard-hero-block')) {
    import('~scripts/blocks/standard-hero');
  }
  if (document.querySelector('.contact-form-block')) {
    import('~scripts/blocks/contact-form');
  }
  if (document.querySelector('.faq-block')) {
    import('~scripts/blocks/faq');
  }
  if (document.querySelector('.js-introduction-text-block')) {
    import('~scripts/blocks/introduction-text');
  }
  if (document.querySelector('.testimonial-block')) {
    import('~scripts/blocks/testimonial-carousel');
  }
  if (document.querySelector('.process-carousel-block')) {
    import('~scripts/blocks/process-carousel');
  }
  if (document.querySelector('.text-media-block')) {
    import('~scripts/blocks/text-media');
  }
  
  if ( document.querySelector('.js-map') ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('google-maps:loaded', () => {
      // alert('Google Maps loaded');
    });

    VendorScriptLoader.outputGoogleMapsScriptTag();
  }

  if ( document.getElementById('feed') ) {
    // Loads component only after vendor files are loaded
    document.addEventListener('multiple-vendors:loaded', () => {
      import('~scripts/blocks/feed');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue', 'vendor-vuex']);
  }

  if (document.querySelector('.js-full-service-image-block')) {
    import('~scripts/blocks/full-service-image').then(component => {
      const FullServiceImageBlock = component.default;
      FullServiceImageBlock.init();
    });
  }

  if (document.querySelector('.js-latest-news-block__mobile-swiper')) {
    import('~scripts/blocks/latest-news');
  }

  if ( document.querySelector('.js-tabs-block') ) {
    import('~scripts/blocks/tabs').then(component => {
      component.default.init();
    });
  }
}

/**
 * Code-splitting :: Components
 *
 * Manages components that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerComponents() {
  if ( document.querySelector('.js-example-component') ) {
    import('~scripts/components/example');
  }

  // Search Overlay
  if ( document.querySelector('.js-search-overlay') ) {
    import('~scripts/components/search-overlay').then(component => {
      component.default.init();
    });
  }

  // Form :: custom choice fields
  if ( document.querySelectorAll('.form-style select').length ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-choices:loaded', () => {
      import('~scripts/components/form/form-custom-select-styles').then(component => {
        component.default.init('.form-style');
      });
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-choices');
  }

  // Form :: field validation feedback
  if ( document.querySelectorAll('.form-style').length ) {
    import('~scripts/components/form/form-field-validation-feedback').then(component => {
      const FormFieldValidationFeedback = component.default;
      FormFieldValidationFeedback.init('.form-style');
    });
  }

  // Generic form (i.e. search form)
  if ( document.querySelectorAll('.js-generic-form  select').length ) {
    import('~scripts/components/form/generic-form-custom-select-styles').then(component => {
      component.default.init('.js-generic-form');
    });
  }

  // Wordpress pagination
  if ( document.querySelector('.js-wp-pagination') ) {
    import('~styles/components/wp-pagination/index.scss');
  }

  if ( document.querySelector('.js-video-autoplay') ) {
    import('~scripts/components/video/video-autoplay').then(component => {
      component.default.init();
    });
  }

  if ( document.querySelector('.js-lottie-file') ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-lottie-player:loaded', () => {
      import('~scripts/components/lottie-file');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-lottie-player');
  }

  // Custom horizontal scrollbar
  if ( document.querySelector('.js-horizontal-scrollbar') ) {
    import('~scripts/components/custom-scrollbar/horizontal-scrollbar').then(component => {
      const HorizontalScrollbar = component.default;

      // Adjusts custom scrollbar's width so that it corresponds to the difference in widths
      // between the scrollable content and the scrollbar area.
      // This function will have 1 argument: 'instance'
      const calculateScrollbarWidthOffsetFn = () => {
        // const scrollbarContainerRightPos = instance._customScrollbarContainerEl.getBoundingClientRect().right;
        // const viewportWidth = window.innerWidth;
        //
        // // Calculate the space between the scrollbar's right edge and the viewport's right edge
        // const space = Math.floor(viewportWidth - scrollbarContainerRightPos);
        //
        // return space / 2;

        return 0;
      };

      document.querySelectorAll('.js-horizontal-scrollbar').forEach(node => {
        new HorizontalScrollbar(node, calculateScrollbarWidthOffsetFn);
      });
    });
  }

  if ( document.querySelector('.sticky-content') ) {
    import('~scripts/blocks/sticky-content');
  }
  
  // if ( document.querySelector('.js-simple-accordion') ) {
  //   import('~scripts/components/accordion/simple-accordion').then(component => {
  //     const SimpleAccordion = component.default;
  //
  //     document.querySelectorAll('.js-simple-accordion').forEach(node => {
  //       new SimpleAccordion(node);
  //     });
  //   });
  // }
}


/**
 * DOMContentLoaded events should be listened to on this file only.
 */
document.addEventListener('DOMContentLoaded', registerBlocks);
document.addEventListener('DOMContentLoaded', registerComponents);

/**
 * Load common components here
 */
document.addEventListener('DOMContentLoaded', () => {
  // Example
  // // Initiates Header Nav Menu
  HeaderNavHeader.init();

  // Applies lazy-loading to images on the page
  LazyLoad.init();

  // Initiates Anchor Smooth Scroll utility
  AnchorSmoothScroll.init();

  // Navigation link toggler for current active item
  // NavLinkToggler.init();
});
